import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { usePRD4060_R01Store } from "./Store_PRD4060_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_PRD4060_R01 } from "./Content_PRD4060_R01";
import { SearchSection_PRD4060_R01 } from "./SearchSection_PRD4060_R01";
import { Table_PRD4060_R01 } from "./Table_PRD4060_R01";
import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { PRD4060_R01Dto } from "./Dto_PRD4060_R01";

export const Container_PRD4060_R01 = () => {
    const { initData } = usePRD4060_R01Store();
    const { setMessage } = useUiuxStore();
    const gridRef = useRef<AgGridReact<PRD4060_R01Dto>>(null);

    const {
        fetchData,
        handleExcelClick,
    } = Content_PRD4060_R01({
        setMessage,
    });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onSaveClick={undefined}
                onDeleteClick={() => {}}
                onInitClick={initData}
                onExcelClick={handleExcelClick}
            />
            <SearchSection_PRD4060_R01 />
            <div className="flex flex-1 p-[12px] gap-[4px] min-h-0">
                <div className="h-full w-full">
                    <Table_PRD4060_R01 gridRef={gridRef} />
                </div>
            </div>
            <Message />
        </div>
    );
};

